import Swiper from 'swiper'
import { Navigation, Thumbs } from 'swiper/modules'

window.initSwiper = () => {
  const swipers = document.querySelectorAll('.swiper')
  const swiperThumbToggle = document.querySelector(
    '[data-gallery-thumbs-toggle]',
  )
  const galleryThumbs = document.querySelector('[data-gallery-thumbs]')

  swiperThumbToggle &&
    swiperThumbToggle.addEventListener('click', () => {
      galleryThumbs.classList.toggle('is-expanded')
      swiperThumbToggle.classList.toggle('is-expanded')
    })

  swipers &&
    swipers.forEach((item) => {
      const currSwiper = new Swiper(item, {
        modules: [Navigation, Thumbs],
        slidesPerView: 'auto',
        scrollOnFocus: false,
        keyboard: {
          enabled: true,
        },
        navigation: {
          prevEl: item
            .closest('.swiper-parent')
            .querySelector('.swiper-button-prev'),
          nextEl: item
            .closest('.swiper-parent')
            .querySelector('.swiper-button-next'),
        },
      })

      if (item.closest('.swiper-parent').contains(galleryThumbs)) {
        galleryThumbs.querySelectorAll('button').forEach((button) => {
          button.addEventListener('click', (e) => {
            var slideIndex = e.target.dataset.slideIndex
            if (slideIndex) {
              currSwiper.slideTo(slideIndex)
            }
          })
        })
      }
    })
}

document.addEventListener('DOMContentLoaded', initSwiper)
